import './mermaid-component';
import './mermaid-editor-menu';

import { BlockModel, defineBlockSchema } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { PiqueMermaidBlockService } from './mermaid-service';

export type MermaidProps = {
  code: string;
};

export const PiqueMermaidBlockSchema = defineBlockSchema({
  flavour: 'affine:embed-mermaid',
  props: (): MermaidProps => ({
    code: '',
  }),
  metadata: {
    version: 1,
    role: 'content',
  },
  toModel: () => new PiqueMermaidBlockModel(),
});

export class PiqueMermaidBlockModel extends BlockModel<MermaidProps> {}

export const PiqueMermaidBlockSpec = {
  schema: PiqueMermaidBlockSchema,
  service: PiqueMermaidBlockService,
  view: {
    component: literal`affine-mermaid`,
  },
};

declare global {
  namespace BlockSuite {
    interface BlockModels {
      'affine:embed-mermaid': PiqueMermaidBlockModel;
    }
  }
}
